import themeSlice from "../slices/themeSlice";

export const { themeRequest, themeSuccess, themeFailure } = themeSlice.actions;
